export const FETCH_AI_WALLETS = "app/AICredits/FETCH_AI_WALLETS";
export const FETCH_AI_WALLETS_SUCCESS =
  "app/AICredits/FETCH_AI_WALLETS_SUCCESS";
export const FETCH_AI_WALLETS_FAILURE =
  "app/AICredits/FETCH_AI_WALLETS_FAILURE";

export const FETCH_AI_LEDGER = "app/AICredits/FETCH_AI_LEDGER";
export const FETCH_AI_LEDGER_SUCCESS = "app/AICredits/FETCH_AI_LEDGER_SUCCESS";
export const FETCH_AI_LEDGER_FAILURE = "app/AICredits/FETCH_AI_LEDGER_FAILURE";

export const FETCH_AI_PLANS = "app/AICredits/FETCH_AI_PLANS";
export const FETCH_AI_PLANS_SUCCESS = "app/AICredits/FETCH_AI_PLANS_SUCCESS";
export const FETCH_AI_PLANS_FAILURE = "app/AICredits/FETCH_AI_PLANS_FAILURE";

export const START_AI_CHECKOUT = "app/AICredits/START_AI_CHECKOUT";
export const START_AI_CHECKOUT_SUCCESS =
  "app/AICredits/START_AI_CHECKOUT_SUCCESS";
export const START_AI_CHECKOUT_FAILURE =
  "app/AICredits/START_AI_CHECKOUT_FAILURE";

export const COMPLETE_AI_CHECKOUT = "app/AICredits/COMPLETE_AI_CHECKOUT";
export const COMPLETE_AI_CHECKOUT_SUCCESS =
  "app/AICredits/COMPLETE_AI_CHECKOUT_SUCCESS";
export const COMPLETE_AI_CHECKOUT_FAILURE =
  "app/AICredits/COMPLETE_AI_CHECKOUT_FAILURE";
